module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance-add-account/finance-add-account.component.css
// module id = ./src/app/finance-add-account/finance-add-account.component.css
// module chunks = main